import type { CalculationContext } from '@/features/execute-calculation-set/overmind/calculation/actions';

export type CalculationSetExecutionUrl = string;
export const sharing = {
  shareCalculationSetExecution(calculationContext: CalculationContext) {
    navigator.clipboard.writeText(
      this.toCalculationSetExecutionUrl(calculationContext)
    );
  },
  toCalculationSetExecutionUrl(
    calculationContext: CalculationContext
  ): CalculationSetExecutionUrl {
    const gridVersionName = calculationContext.gridVersionName
      ? `&gridVersionName=${calculationContext.gridVersionName}`
      : '';
    return `${location.origin}/execute-calculation-set-using?calculationSetId=${
      calculationContext.calculationSetId
    }&tenantId=${
      calculationContext.tenantId
    }&relatedObjectId=${encodeURIComponent(
      calculationContext.relatedObjectId
    )}${gridVersionName}`;
  }
};
